import React from "react";
import { useDispatch } from "react-redux";
import CustomSingleSelect, { CustomSingleSelectModel } from "../../../../components/CustomSingleSelect";
import CustomSwitch from "../../../../components/CustomSwitch";
import { Helpers } from "../../../../helpers/Helpers";
import { GetCompanyListResponseItem } from "../../../../models/response/company/GetCompanyListResponse";
import { storeFastFirm, storeImageViewer } from "../../../../redux/reducers/authSlice";
import { CompanyService } from "../../../../services/CompanyService";
import { KTCard } from "../../../../_metronic/helpers/components/KTCard";
import { KTCardBody } from "../../../../_metronic/helpers/components/KTCardBody";
import CustomTextInput from "../../../../components/CustomTextInput";

interface Props {
    generalInformationRef: any
    name: string | undefined
    setName: React.Dispatch<React.SetStateAction<string | undefined>>
    surname: string | undefined
    setSurname: React.Dispatch<React.SetStateAction<string | undefined>>
    phone1: string | undefined
    setPhone1: React.Dispatch<React.SetStateAction<string | undefined>>
    phone1Ref: React.MutableRefObject<HTMLInputElement | null>
    phone2: string | undefined
    setPhone2: React.Dispatch<React.SetStateAction<string | undefined>>
    phone2Ref: React.MutableRefObject<HTMLInputElement | null>
    selectedRelatedCompany: CustomSingleSelectModel | undefined
    setSelectedRelatedCompany: React.Dispatch<React.SetStateAction<CustomSingleSelectModel | undefined>>
    email: string | undefined
    setEmail: React.Dispatch<React.SetStateAction<string | undefined>>
    isCustomActive: boolean
    setIsCustomActive: React.Dispatch<React.SetStateAction<boolean>>
    workStartDate: string | undefined
    setWorkStartDate: React.Dispatch<React.SetStateAction<string | undefined>>
    workEndDate: string | undefined
    setWorkEndDate: React.Dispatch<React.SetStateAction<string | undefined>>
    address: string | undefined
    setAddress: React.Dispatch<React.SetStateAction<string | undefined>>
    desc: string | undefined
    setDesc: React.Dispatch<React.SetStateAction<string | undefined>>
    RFID: string | undefined
    setRFID: React.Dispatch<React.SetStateAction<string | undefined>>
    driverFileB64: string
    driverFileRef: any
    setDriverFile: React.Dispatch<React.SetStateAction<File | undefined>>
    setDriverFileB64: React.Dispatch<React.SetStateAction<string>>
    handleFileRead: (event: any, setFunction: React.Dispatch<React.SetStateAction<string>>) => Promise<void>
    dateOfBirth: string | undefined
    setDateOfBirth: React.Dispatch<React.SetStateAction<string | undefined>>
    placeOfBirth: string | undefined
    setPlaceOfBirth: React.Dispatch<React.SetStateAction<string | undefined>>
}

const GeneralInformation = ({
    generalInformationRef,
    name,
    setName,
    setSurname,
    surname,
    phone1,
    phone1Ref,
    phone2,
    phone2Ref,
    setPhone1,
    setPhone2,
    selectedRelatedCompany,
    setSelectedRelatedCompany,
    email,
    setEmail,
    isCustomActive,
    setIsCustomActive,
    setWorkEndDate,
    setWorkStartDate,
    workEndDate,
    workStartDate,
    address,
    desc,
    RFID,
    setAddress,
    setDesc,
    setRFID,
    driverFileB64,
    driverFileRef,
    setDriverFile,
    setDriverFileB64,
    handleFileRead,
    dateOfBirth,
    setDateOfBirth,
    placeOfBirth,
    setPlaceOfBirth
}: Props) => {
    const dispatch = useDispatch();

    return (
        <div className='containerPart' ref={generalInformationRef}>
            <KTCard className="ebbe-card mt-10">
                <KTCardBody>
                    <h4 className="mb-10 text-black">Genel Bilgiler</h4>

                    <div className='row'>
                        <div className="col-md-9">
                            <div className="row">
                                <div className="col-md-6">
                                    <div>
                                        <label htmlFor="exampleFormControlInput1" className="form-label required">Adı</label>
                                        <input style={{ border: '1px solid #F1F1F4' }} value={name} onChange={(e) => setName(e.target.value)} type="text" className="form-control form-control-solid" />
                                    </div>

                                    <div className="mt-5">
                                        <label htmlFor="exampleFormControlInput1" className="form-label required">Soyadı</label>
                                        <input style={{ border: '1px solid #F1F1F4' }} value={surname} onChange={(e) => setSurname(e.target.value)} type="text" className="form-control form-control-solid" />
                                    </div>

                                    <div className="mt-5">
                                        <label htmlFor="exampleFormControlInput1" className="form-label">Doğum Tarihi</label>
                                        <input style={{ border: '1px solid #F1F1F4' }} value={dateOfBirth} onChange={(e) => setDateOfBirth(e.target.value)} type="date" className="form-control form-control-solid" />
                                    </div>

                                    <div className="mt-5">
                                        <label htmlFor="exampleFormControlInput1" className="form-label">Doğum Yeri</label>
                                        <input style={{ border: '1px solid #F1F1F4' }} value={placeOfBirth} onChange={(e) => setPlaceOfBirth(e.target.value)} type="text" className="form-control form-control-solid" />
                                    </div>

                                    <div className="mt-5">
                                        <label htmlFor="exampleFormControlInput1" className="form-label required">Bağlı Olduğu Firma</label>

                                        <CustomSingleSelect
                                            selectedValue={selectedRelatedCompany}
                                            onChange={setSelectedRelatedCompany}
                                            insertable={{
                                                tooltipText: 'Firma seçilmeden basıldığında Yeni firma tanımlaması yapılmasını, firma seçimi yapıldıktan sonra basıldığında ise seçilen firmanın bilgilerinin Güncellenmesini sağlar.',
                                                onClick: () => {
                                                    dispatch(storeFastFirm({
                                                        companyId: selectedRelatedCompany?.value,
                                                        isSupplier: true,
                                                        onSubmit: async (response) => {
                                                            setSelectedRelatedCompany({ label: response.name, value: response.companyId })
                                                        }
                                                    }))
                                                }
                                            }}
                                            onMenuOpen={() => CompanyService.getCompanyList({ isSupplier: true })}
                                            labelName='name'
                                            valueName='companyId'
                                        />
                                    </div>

                                    <div className="mt-5">
                                        <label htmlFor="exampleFormControlInput1" className="form-label required">Telefon 1</label>
                                        <input ref={phone1Ref} style={{ border: '1px solid #F1F1F4' }} value={phone1} onChange={(e) => setPhone1(e.target.value)} className="form-control form-control-solid" />
                                    </div>

                                    <div className="mt-5">
                                        <label htmlFor="exampleFormControlInput1" className="form-label">Telefon 2</label>
                                        <input ref={phone2Ref} style={{ border: '1px solid #F2F2F4' }} value={phone2} onChange={(e) => setPhone2(e.target.value)} className="form-control form-control-solid" />
                                    </div>

                                    <div className="mt-5">
                                        <label htmlFor="exampleFormControlInput1" className="form-label">E-Posta</label>
                                        <input style={{ border: '1px solid #F1F1F4' }} value={email} onChange={(e) => setEmail(e.target.value)} type="text" className="form-control form-control-solid" />
                                    </div>
                                </div>

                                <div className="col-md-6">
                                    <div>
                                        <label htmlFor="exampleFormControlInput1" className="form-label">İşe Başlama Tarihi</label>
                                        <input style={{ border: '1px solid #F1F1F4' }} value={workStartDate} onChange={(e) => setWorkStartDate(e.target.value)} type="date" className="form-control form-control-solid" />
                                    </div>

                                    <div className="mt-5">
                                        <label htmlFor="exampleFormControlInput1" className="form-label">İşe Ayrılma Tarihi</label>
                                        <input style={{ border: '1px solid #F1F1F4' }} value={workEndDate} onChange={(e) => setWorkEndDate(e.target.value)} type="date" className="form-control form-control-solid" />
                                    </div>

                                    <div className="mt-5">
                                        <label htmlFor="exampleFormControlInput1" className="form-label">Adres</label>
                                        <textarea value={address} onChange={(e) => setAddress(e.target.value)} style={{ border: '1px solid #F1F1F4', width: '100%', height: '130px', resize: 'none' }} className="form-control form-control-solid" />
                                    </div>

                                    <div className="mt-5">
                                        <label htmlFor="exampleFormControlInput1" className="form-label">Personel Kart No (RFID)</label>
                                        <CustomTextInput value={RFID} setValue={setRFID} />
                                    </div>

                                    <div className="mt-5">
                                        <label htmlFor="exampleFormControlInput1" className="form-label">Açıklama</label>
                                        <textarea value={desc} onChange={(e) => setDesc(e.target.value)} style={{ border: '1px solid #F1F1F4', width: '100%', height: '130px', resize: 'none' }} className="form-control form-control-solid" />
                                    </div>

                                    <div className="mt-5">
                                        <label htmlFor="exampleFormControlInput1" className="form-label">Aktif</label>

                                        <CustomSwitch isActive={isCustomActive} setIsActive={setIsCustomActive} />
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="col-md-3">
                            <label htmlFor="exampleFormControlInput1" className="form-label">Sürücü Resmi</label>

                            <div>
                                <img onClick={() => dispatch(storeImageViewer([driverFileB64]))} style={{ width: '100%' }} className="actionIcon img img-thumbnail" src={driverFileB64} />

                                <div className='mt-5 p-3 img img-thumbnail d-flex'>
                                    <div className='d-flex flex-grow-1'>
                                        <input accept="image/*" ref={driverFileRef} onChange={(e) => { setDriverFile(e && e.target && e.target.files && e.target.files.length > 0 ? e.target.files[0] : undefined); handleFileRead(e, setDriverFileB64); }} type="file" className="form-control form-control-solid" />
                                    </div>

                                    {
                                        !Helpers.isEmpty(driverFileB64) && (
                                            <div style={{ marginLeft: 15 }} className='d-flex align-items-center'>
                                                <i onClick={() => { setDriverFile(undefined); setDriverFileB64(Helpers.getPlaceholder()); driverFileRef.current.value = ""; }} style={{ fontSize: 18 }} className='actionIcon text-danger fa fa-trash' />
                                            </div>
                                        )
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </KTCardBody>
            </KTCard>
        </div>
    )
}

export default GeneralInformation;